var ContentComponent = /** @class */ (function () {
    function ContentComponent() {
    }
    return ContentComponent;
}());
export { ContentComponent };
